export const environment = {
  production: false,
  apiBase: 'https://dev-ms.mystory.press',
};
